'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _keyOrIndexToProperty = require('./keyOrIndexToProperty');

var _keyOrIndexToProperty2 = _interopRequireDefault(_keyOrIndexToProperty);

var _has = require('unmutable/lib/has');

var _has2 = _interopRequireDefault(_has);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (key) {
    return function (parcelData) {
        var property = (0, _keyOrIndexToProperty2.default)(key)(parcelData);
        return (0, _has2.default)(property)(parcelData.value);
    };
};


//////////////////
// WEBPACK FOOTER
// ./~/parcels/lib/parcelData/has.js
// module id = 343
// module chunks = 35783957827783